import { jsx as o, Fragment as b, jsxs as w } from "react/jsx-runtime";
import { useState as L, useMemo as k, useCallback as y, useLayoutEffect as v } from "react";
import t from "./styles.module.less.js";
import A from "./logo.webp.js";
import { usePathname as N } from "../../../utils/use-pathname.js";
import { AccountLink as I } from "./account-link/index.js";
import { FLOATING_CONTAINER_ID as m } from "./index.js";
import { areasOfLawData as C } from "../../../constants.js";
import { convertToKebabCase as D } from "../../../utils/case-conversion.js";
import { DropdownMenuItemDesktop as g } from "./dropdown-menu-item/index.js";
import { getAboutLinks as E } from "./get-about-links.js";
import { ForLawyersMenuButtonDesktop as M } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemDesktop as S } from "./get-help-menu-item/index.js";
import { MenuChatButtonDesktop as R } from "./chat-button/index.js";
const $ = "/help", J = (s) => {
  const { getTranslation: a, language: e, isLawyerSupported: d = !1 } = s, n = N(), [i, f] = L(!1), c = k(() => {
    const r = C[e];
    if (r)
      return [
        ...r.map((u) => ({
          ...u,
          path: `/${e}/${D(u.title)}`
        }))
      ];
  }, [e]), l = y(
    (r) => {
      switch (r) {
        case "/chat":
          return n === "/chat";
        case "/about":
          return n === `/${e}/about`;
        case "/help":
          return n === $;
        case "/library":
          return n === `/${e}/library`;
        case "/account":
          return n === "/account";
        case "/for-lawyers/legal-network":
          return n === `/${e}/for-lawyers/legal-network`;
        default:
          return !1;
      }
    },
    [n, c, e]
  );
  return v(() => {
    const r = () => {
      var h, p;
      (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0) > 80 ? ((h = document.getElementById(m)) == null || h.classList.add(t.shrink), f(!0)) : ((p = document.getElementById(m)) == null || p.classList.remove(t.shrink), f(!1));
    };
    return window.addEventListener("scroll", r), document.body.addEventListener("scroll", r), r(), () => {
      window.removeEventListener("scroll", r), document.body.removeEventListener("scroll", r);
    };
  }, []), /* @__PURE__ */ o(b, { children: /* @__PURE__ */ o("div", { className: t.floatingContainer, id: m, children: /* @__PURE__ */ w("div", { className: t.menuContentContainer, children: [
    /* @__PURE__ */ o(
      "a",
      {
        href: e ? `/${e}` : "/",
        className: t.logoContainer,
        children: /* @__PURE__ */ o(
          "img",
          {
            src: A,
            alt: "logo",
            width: 0,
            height: 20,
            className: t.logo
          }
        )
      }
    ),
    /* @__PURE__ */ w("div", { className: t.menuLinksContainer, children: [
      d ? /* @__PURE__ */ o(
        S,
        {
          language: e,
          titleLabel: a("pages.get-help"),
          getTranslation: a,
          hasShrunk: i,
          isLawyerSupported: !0,
          onRequestLawyer: s.onRequestLawyer,
          isActive: l(
            "/help"
            /* HELP */
          )
        }
      ) : /* @__PURE__ */ o(
        R,
        {
          getTranslation: a,
          isScrolledHeader: i
        }
      ),
      d ? null : /* @__PURE__ */ o("div", { className: t.spacer }),
      c ? /* @__PURE__ */ o(
        g,
        {
          language: e,
          items: c,
          titleLabel: a("pages.areas-of-law"),
          hasShrunk: i,
          link: `/${e}/library`,
          classNames: {
            container: t.subMenuContainer,
            itemRow: t.offsetDropdownItemRow
          },
          isActive: l(
            "/library"
            /* KNOWLEDGE_BASE */
          )
        }
      ) : null,
      /* @__PURE__ */ o(
        g,
        {
          language: e,
          titleLabel: a("pages.about"),
          link: `/${e}/about`,
          hasShrunk: i,
          items: E({ language: e, getTranslation: a }),
          classNames: {
            container: t.subMenuContainer,
            itemRow: t.offsetDropdownItemRow
          },
          isActive: l(
            "/about"
            /* ABOUT */
          )
        }
      ),
      /* @__PURE__ */ o(
        M,
        {
          language: e,
          getTranslation: a,
          isScrolledHeader: i,
          isActive: l(
            "/for-lawyers/legal-network"
            /* FOR_LAWYERS */
          )
        }
      ),
      /* @__PURE__ */ o(
        I,
        {
          isScrolledHeader: i,
          isActive: l(
            "/account"
            /* ACCOUNT */
          ),
          isAuthenticated: s.isAuthenticated,
          userImage: s.userImage,
          openAuthModal: s.openAuthModal,
          logout: s.logout,
          hasNotifications: s.hasNotifications,
          language: e,
          getTranslation: a
        }
      )
    ] })
  ] }) }) });
};
export {
  J as DesktopMenu
};
